import { ActionCreatorHelper } from "../saga-reducers-factory-patch";

const actionsList = ["INIT", "SEND_CODE_BY_EMAIL", "REGISTER_BY_CODE", "REGENERATE_CODE", "GET_REGISTRATION_DETAILS"];

export const types = ActionCreatorHelper.createTypes(actionsList, "REGISTRATION_");
export const actions = ActionCreatorHelper.createActions(actionsList, "REGISTRATION_");
